"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hrTrainingEnrollmentQuerySchema = exports.hrTrainingCompleteSchema = exports.hrTrainingMarkAbsentSchema = exports.hrTrainingMarkAttendedSchema = exports.hrTrainingEnrollmentCreateSchema = exports.hrTrainingSessionQuerySchema = exports.hrTrainingSessionCreateSchema = exports.hrTrainingProgramQuerySchema = exports.hrTrainingProgramUpdateSchema = exports.hrTrainingProgramCreateSchema = exports.hrTrainingEnrollmentStatusEnum = exports.hrTrainingSessionStatusEnum = void 0;
const zod_1 = require("zod");
/**
 * HR PHASE 4 — training & development. `HrTrainingProgram` is a
 * CONFIGURABLE catalogue (like credential/document types) — `category` is
 * free text, never a closed enum.
 */
exports.hrTrainingSessionStatusEnum = zod_1.z.enum(['SCHEDULED', 'COMPLETED', 'CANCELLED']);
exports.hrTrainingEnrollmentStatusEnum = zod_1.z.enum(['ENROLLED', 'ATTENDED', 'ABSENT', 'COMPLETED']);
exports.hrTrainingProgramCreateSchema = zod_1.z.object({
    code: zod_1.z.string().trim().min(2).max(30),
    name: zod_1.z.string().trim().min(2).max(200),
    category: zod_1.z.string().trim().max(100).optional(),
    isMandatory: zod_1.z.coerce.boolean().optional(),
    validityMonths: zod_1.z.coerce.number().int().positive().max(120).optional(),
});
exports.hrTrainingProgramUpdateSchema = exports.hrTrainingProgramCreateSchema.partial().extend({
    isActive: zod_1.z.coerce.boolean().optional(),
});
exports.hrTrainingProgramQuerySchema = zod_1.z.object({
    includeInactive: zod_1.z.coerce.boolean().optional(),
});
exports.hrTrainingSessionCreateSchema = zod_1.z.object({
    programId: zod_1.z.string().uuid(),
    sessionDate: zod_1.z.coerce.date(),
    trainer: zod_1.z.string().trim().max(200).optional(),
    venue: zod_1.z.string().trim().max(200).optional(),
    capacity: zod_1.z.coerce.number().int().positive().max(1000).optional(),
});
exports.hrTrainingSessionQuerySchema = zod_1.z.object({
    programId: zod_1.z.string().uuid().optional(),
    status: exports.hrTrainingSessionStatusEnum.optional(),
    cursor: zod_1.z.string().min(1).max(512).optional(),
    limit: zod_1.z.coerce.number().int().positive().max(200).default(50),
});
exports.hrTrainingEnrollmentCreateSchema = zod_1.z.object({
    sessionId: zod_1.z.string().uuid(),
    employeeId: zod_1.z.string().uuid(),
});
/** Marking ATTENDED is a distinct act from COMPLETED — attendance alone doesn't imply passing. */
exports.hrTrainingMarkAttendedSchema = zod_1.z.object({});
exports.hrTrainingMarkAbsentSchema = zod_1.z.object({});
exports.hrTrainingCompleteSchema = zod_1.z.object({
    score: zod_1.z.coerce.number().int().min(0).max(100).optional(),
});
exports.hrTrainingEnrollmentQuerySchema = zod_1.z.object({
    employeeId: zod_1.z.string().uuid().optional(),
    sessionId: zod_1.z.string().uuid().optional(),
    status: exports.hrTrainingEnrollmentStatusEnum.optional(),
    cursor: zod_1.z.string().min(1).max(512).optional(),
    limit: zod_1.z.coerce.number().int().positive().max(200).default(50),
});
//# sourceMappingURL=hr-training.schema.js.map